const { KEYS } = require('utils/localStorage/Search');
const Storage = require('utils/localStorage/Storage');
const searchTypeAhead = require('services/api/search-n-browse/searchTypeAhead');
const TYPES = require('reducers/search').ACTION_TYPES;
const historyLocationActions = require('actions/framework/HistoryLocationActions');
const searchConstants = require('utils/Search');
const searchUtils = require('utils/Search');
const ufeApi = require('services/api/ufeApi');
const cachingConcern = require('services/api/cache');
const { withInterstice } = require('utils/decorators');
const isFunction = require('utils/functions/isFunction.js');
const { getProductsFromKeyword } = require('services/api/search-n-browse/searchProductsByKeyword');
const SEARCH_TYPES = require('reducers/page/search').ACTION_TYPES;
const { SET_SEARCH } = require('../constants/actionTypes/search');
const { breakpoints } = require('../style/config');
const { buildProductImageSrc } = require('../utils/product');
const { PRODUCT_TILE: IMAGE_SIZE } = require('../style/imageSizes');
const catalogUtils = require('utils/Catalog');
const Location = require('utils/Location');
const HistoryService = require('services/History');

const { SALE_KEYWORDS } = require('constants/Search.js');

const URLS = {
    SEARCH_URL: '/search?keyword=',
    SEARCH_TYPEAHEAD_URL: '/api/catalog/search?type=typeahead&q='
};

const STORAGE_KEYS = { STORAGE_PREVIOUS_RESULTS: KEYS.STORAGE_PREVIOUS_RESULTS };

const MAX_SEARCH_SUGGESTIONS_COUNT = 10;

const SPACE_REPLACE_STRING = '%20';

const SALE_REDIRECT_PATH = '/sale';
const HOME_REDIRECT_PATH = '/';

const identity = (keyString) => keyString;
const allowedParamKeys = {
    pageSize: identity,
    currentPage: (currentPageStr) => parseInt(currentPageStr[0], 10) || 1,
    ph: identity,
    pl: identity,
    ref: identity,
    sortBy: identity,
    ptype: identity,
    node: identity
};

const formatRefinementString = val => typeof val === 'string' ?
    val.replace(' ', SPACE_REPLACE_STRING) : val ? val.toString() : '';

const MAX_IMAGES_TO_PRELOAD = 8;

const getImagesToPreload = ({ products = [] } = {}) => {
    const imagesToPreload = [];
    const generateSrcs = true;
    let size;

    if (window.matchMedia(breakpoints.smMin).matches) {
        size = IMAGE_SIZE[1];
    } else {
        size = IMAGE_SIZE;
    }

    products.slice(0, MAX_IMAGES_TO_PRELOAD).forEach(({
        currentSku: { skuId: id }, heroImage: image
    }) => {
        const skuImages = { image };
        const [, , x1PixelDensityUrl, x2PixelDensityUrl] = buildProductImageSrc({
            id,
            skuImages,
            size,
            generateSrcs
        });
        imagesToPreload.push({
            x1PixelDensityUrl,
            x2PixelDensityUrl
        });
    });

    return imagesToPreload;
};

function mapResults(results) {
    return results && results.length ?
        results.map((result) => {
            if (result instanceof Object) {
                let searchResult = result.brandName ? result.brandName + ' - ' : '';
                searchResult += result.productName;
                result.value = (typeof result.term !== 'undefined') ?
                    result.term : searchResult;
            }

            return result;
        }) : [];
}

function showSearchResults(keyword, results) {
    return {
        type: TYPES.SHOW_SEARCH_RESULTS,
        keyword: keyword,
        results: mapResults(results.slice(0, MAX_SEARCH_SUGGESTIONS_COUNT))
    };
}

function showPreviousSearchResults() {
    const data = Storage.local.getItem(KEYS.STORAGE_PREVIOUS_RESULTS);
    return {
        type: TYPES.SHOW_PREVIOUS_SEARCH,
        results: data ? mapResults(data.slice(0, KEYS.MAX_PREVIOUS_RESULTS_COUNT)) : []
    };
}

function addRefinement(refinementId, removeFirst) {
    return (dispatch, getState) => {
        const refinementToAdd = formatRefinementString(refinementId);

        let queryParams =
            Object.assign({}, getState().historyLocation.queryParams);

        const catalogService = Sephora.Util?.InflatorComps?.services?.CatalogService;
        if (catalogService && catalogService.isNLPCatalog()) {
            queryParams =
                Sephora.Util.getConstructorQueryStringParams(queryParams);
        }

        const currentRefinements =
            searchUtils.getRefinementsFromQueryParams(queryParams);

        /* This condition applies for Up funnel filters */
        if (currentRefinements.length && removeFirst) {
            const filterKeyValue = refinementId.split('=')[0];
            const refinementIndex = currentRefinements.findIndex(ref => {
                return ref.split('=')[0] === filterKeyValue;
            });
            if (refinementIndex !== -1) {
                currentRefinements.splice(refinementIndex, 1);
            }
        }

        if (currentRefinements.indexOf(refinementToAdd) === -1) {
            currentRefinements.push(refinementToAdd);
            queryParams.ref = currentRefinements;
            delete queryParams.currentPage;

            if (queryParams.keyword && queryParams.keyword[0]) {
                queryParams.keyword = [catalogUtils.encodeDecodedParam(queryParams.keyword[0])];
            }
            dispatch(historyLocationActions.goTo({ queryParams }));
        }
    };
}

function removeRefinements(refinementsIds) {
    return (dispatch, getState) => {
        const refinementsToRemove = refinementsIds.map(one => formatRefinementString(one));

        let queryParams =
            Object.assign({}, getState().historyLocation.queryParams);

        const catalogService = Sephora.Util?.InflatorComps?.services?.CatalogService;
        if (catalogService && catalogService.isNLPCatalog()) {
            queryParams =
                Sephora.Util.getConstructorQueryStringParams(queryParams);
        }

        const currentRefinements =
            searchUtils.getRefinementsFromQueryParams(queryParams);

        const newRefinements = currentRefinements.filter(
            one => (decodeURIComponent(refinementsToRemove)).indexOf(decodeURIComponent(one)) === -1
        );

        const shouldURLChange =
            newRefinements.length !== currentRefinements.length;

        if (shouldURLChange) {
            queryParams.ref = newRefinements;
            delete queryParams.currentPage;
            dispatch(historyLocationActions.goTo({ queryParams }));
        }
    };
}

function clearRefinements() {
    return (dispatch, getState) => {
        const queryParams = Object.assign({}, getState().historyLocation.queryParams);
        delete queryParams.ref;
        delete queryParams.pl;
        delete queryParams.ph;
        delete queryParams.currentPage;
        dispatch(historyLocationActions.goTo({ queryParams }));
    };
}

function setSorting(sortOptionCode) {
    return (dispatch, getState) => {
        const queryParams = Object.assign({}, getState().historyLocation.queryParams);
        queryParams.sortBy = sortOptionCode;
        delete queryParams.currentPage;
        dispatch(historyLocationActions.goTo({ queryParams }));
    };
}

function setPageNumber(pageNumber) {
    return (dispatch, getState) => {
        const queryParams = Object.assign({}, getState().historyLocation.queryParams);
        queryParams.currentPage = pageNumber;
        dispatch(historyLocationActions.goTo({ queryParams }));
    };
}

function setPrices(prices) {
    return (dispatch, getState) => {
        const queryParams = Object.assign({}, getState().historyLocation.queryParams);

        let priceLow = [];
        let priceHigh = [];

        if (prices && Array.isArray(prices) && prices.length === 2) {
            priceLow = prices[0];
            priceHigh = prices[1];
        }

        queryParams.pl = priceLow;
        queryParams.ph = priceHigh;

        delete queryParams.currentPage;

        dispatch(historyLocationActions.goTo({ queryParams }));
    };
}

function setPageSize(pageSize) {
    return (dispatch, getState) => {
        const queryParams = Object.assign({}, getState().historyLocation.queryParams);
        queryParams.pageSize = pageSize;

        // Per https://jira.sephora.com/browse/ILLUPH-103611, we remove page
        // number whenever page size is changed to the "View all" one, implying
        // that the user is always starting all over from the beginning of
        // the result set and if there are more than view-all max
        // (currently 300) products, they see the paginator and may use it.
        if (pageSize === String(searchConstants.VIEW_ALL_PER_PAGE_MAX)) {
            delete queryParams.currentPage;
        }

        dispatch(historyLocationActions.goTo({ queryParams }));
    };
}

function setCategory(targetUrl) {
    return (dispatch, getState) => {
        const {
            pageSize,
            sortBy
        } = getState().historyLocation.queryParams;

        dispatch(historyLocationActions.goTo({
            path: targetUrl,
            queryParams: {
                pageSize,
                sortBy
            }
        }));
    };
}

function setSearchCategory(categoryNode) {
    return (dispatch, getState) => {
        const {
            node,
            ...queryParams
        } = getState().historyLocation.queryParams;

        if (node && categoryNode) {
            if ((node[0] !== categoryNode) && (parseInt(node[0]) !== parseInt(categoryNode))) {
                queryParams.node = categoryNode;
            }
        } else {
            queryParams.node = categoryNode;
        }

        delete queryParams.currentPage;
        dispatch(historyLocationActions.goTo({ queryParams }));
    };
}

function refreshSearchResults() {
    return { type: TYPES.REFRESH_SEARCH_RESULTS };
}

function setSearchData(data, requestOptions = {}, displayOptions = {}) {
    return {
        type: SET_SEARCH,
        payload: {
            data,
            requestOptions,
            displayOptions
        }
    };
}

function fetchSearchResponse(requestOptions) {
    let resultsPromise;

    const cachedResults = Storage.session.getItem(requestOptions.q);
    if (cachedResults) {
        resultsPromise = Promise.resolve(cachedResults);
        Storage.session.removeItem(requestOptions.q);
    } else {
        resultsPromise = getProductsFromKeyword(requestOptions);
    }

    return resultsPromise;
}

/* eslint-disable object-curly-newline */
const isNewPage = ({ newLocation, previousLocation }) => {
    const { path: newPath, queryParams } = newLocation;
    const { path: prevPath, queryParams: prevQueryParams } = previousLocation;

    const { keyword: newKeyword, node: newNode } = queryParams;
    const { keyword: previousKeyword, node: previousNode } = prevQueryParams;

    const differentPage = prevPath !== newPath || previousKeyword?.[0] !== newKeyword?.[0] || previousNode?.[0] !== newNode?.[0];
    /* eslint-enable object-curly-newline */
    return differentPage;
};

// eslint-disable-next-line object-curly-newline
const createOpenOrUpdatePageRequestOptions = ({ path, queryParams }) => {
    const salePaths = [
        '/sale',
        '/ca/en/sale',
        '/ca/fr/sale'
    ];
    if (salePaths.indexOf(path) !== -1) {
        queryParams.keyword = ['sale'];
    }

    const normalizedParamKeys = Object.keys(queryParams)
        .reduce((allowedParams, key) => {
            if (isFunction(allowedParamKeys[key])) {
                allowedParams[key] = allowedParamKeys[key](queryParams[key]);
            }
            return allowedParams;
        }, {});

    const requestOptions = {
        q: decodeURIComponent(queryParams.keyword[0]),
        ...normalizedParamKeys
    };

    return requestOptions;
};

const openPage = (context) => {
    const {
        newLocation,
        events: {
            onDataLoaded,
            onPageUpdated,
            onError
        }
    } = context;
    const requestOptions = createOpenOrUpdatePageRequestOptions(newLocation);
    let redirectPath;

    if (SALE_KEYWORDS.includes(requestOptions.q) && newLocation.path === '/search') {
        redirectPath = SALE_REDIRECT_PATH;
    }

    if (!requestOptions.q || requestOptions.q === '') {
        redirectPath = HOME_REDIRECT_PATH;
    }

    if (redirectPath) {
        const location = HistoryService.splitURL(redirectPath);
        return HistoryService.linkToSPA(
            null,
            location,
            () => Location.setLocation(redirectPath)
        );
    }

    return dispatch => {
        try {
            return fetchSearchResponse(requestOptions)
                .then(data => {
                    if (data.searchRedirectTarget) {
                        const { targetValue } = data.searchRedirectTarget;
                        const location = HistoryService.splitURL(targetValue);
                        HistoryService.linkToSPA(
                            null,
                            location,
                            () => Location.setLocation(targetValue)
                        );
                    } else {
                        const imagesToPreload = getImagesToPreload(data);
                        onDataLoaded(data, imagesToPreload);
                        data.contextId = catalogUtils.createContextId();
                        dispatch(setSearchData(data, requestOptions));
                        onPageUpdated(data);
                    }
                })
                .catch(error => {
                    const imagesToPreload = getImagesToPreload(error);
                    onDataLoaded(error, imagesToPreload);
                    error.contextId = catalogUtils.createContextId();
                    dispatch(setSearchData(error, requestOptions));
                    onPageUpdated(error);
                });
        } catch (error) {
            onError(error);
            return Promise.reject(error);
        }
    };
};

const updatePage = ({ newLocation }) => (dispatch, getState) => {
    const { page } = getState();
    const currentSearchResults = page['search'];
    const requestOptions = createOpenOrUpdatePageRequestOptions(newLocation);
    const requestControl = {};
    const apiCall = getProductsFromKeyword;
    const abortablePromise = ufeApi.abortable(apiCall, requestControl);
    const interstice = withInterstice(abortablePromise, 0);

    const {
        path: newPath,
        queryParams
    } = newLocation;
    if (newPath === '/sale') {
        queryParams.keyword = ['sale'];
    }

    return cachingConcern.decorate(apiCall, interstice)(requestOptions)
        .then(data => {
            data.contextId = catalogUtils.createContextId();
            // When Loading more products -> Add them instead of replacing them
            if (parseInt(requestOptions.currentPage) === parseInt(currentSearchResults.currentPage || 1) + 1 &&
                // If products received is bigger than the pageSize
                // we dont need to add because it's from cache (using back button)
                data.products.length <= (data.pageSize || 60)) {
                data.products = currentSearchResults.products.concat(data.products);
            }
            dispatch(setSearchData(data, requestOptions));
        })
        .catch(reason => {
            if (reason.responseStatus === 200 && reason.errors && reason.errors.noSearchResult) {
                reason.contextId = catalogUtils.createContextId();
                dispatch(setSearchData(reason, requestOptions));
            } else if (reason.errorCode === ufeApi.ResponseErrorCode.REQUEST_ABORTED) {
                // eslint-disable-next-line no-console
                console.debug('api request got aborted!');
            } else {
                // eslint-disable-next-line no-console
                console.log(reason);
            }
            // eslint-disable-next-line no-console
            console.log('Something went wrong', reason);
        });
};

const getSearchResults = keyword => {
    if (keyword && keyword.length) {
        /* show search suggestions only for keyword more then N characters long */
        if (keyword.length < KEYS.MIN_KEYWORD_LENGTH_FOR_SUGGESTIONS) {
            return showSearchResults(keyword, []);
        } else {
            return (dispatch) => {
                return searchTypeAhead(keyword).
                    then(data => dispatch(showSearchResults(keyword, data.typeAheadTerms))).
                    catch(() => dispatch(showSearchResults(keyword, [])));
            };
        }
    } else {
        return showPreviousSearchResults();
    }
};

module.exports = {
    addRefinement,
    clearRefinements,
    getSearchResults,
    isNewPage,
    openPage,
    refreshSearchResults,
    removeRefinements,
    SEARCH_TYPES,
    setCategory,
    setPageNumber,
    setPageSize,
    setPrices,
    setSearchCategory,
    setSearchData,
    setSorting,
    showPreviousSearchResults,
    STORAGE_KEYS,
    TYPES,
    updatePage,
    URLS
};
